'use strict';
module.exports = require('./dist/fx-ajax.min.js');